export default {
  meta: {
    title: '加盟商申请管理', // 招商管理-加盟商申请管理
    url: '/investment' // 埋点用，记录所属模块
  },
};
